import { CSSProperties, FC } from 'react'
import SVG from 'react-inlinesvg'
import { star, lock } from '../../assets/icon'
import { Icon, Text, Thumb, Decor } from './Bonuses.styled'

type Props = {
    style?: CSSProperties
    addition: any
    lockBonus: boolean,
    disabledDecor?: boolean
}

export const Bonuses: FC<Props> = ({ style, lockBonus, disabledDecor, addition: { image, title, config } }) => {
    return (
        <Thumb
            onClick={() => {
                if (lockBonus) return
                config?.link && window.open(config?.link, '_blank', 'noreferrer')
            }}
            image={image}
            style={style}
            isActive={!lockBonus}
        >
            <Icon>
                {lockBonus ? (
                    <SVG src={lock} width={13} height={13} />
                ) : (
                    <SVG style={{ color: 'var(--bg-button)' }} src={star} width={13} height={13} />
                )}
            </Icon>
            <Text>{title}</Text>
            {!disabledDecor ? <Decor /> : null}
        </Thumb>
    )
}
